import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, TransactionApi, TransactionEntity, TransactionSearchParams } from '@shared/api';

interface ITransactionsStore {
  loading: boolean;
  error: string | null;
  transactions: TransactionEntity[];
  getTransactions: (searchParams: TransactionSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTransactionsStore = create<ITransactionsStore>((set) => ({
  loading: false,
  error: null,
  transactions: [],

  getTransactions: ApiUtils.wrapperApi(async (searchParams: TransactionSearchParams, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await TransactionApi.getTransactions(searchParams, signal);
      set({ transactions: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ transactions: [], loading: false, error: null }),
}));
